import { intersectionObserve } from "./_intersection-observer";

window.addEventListener("load", function () {
	const infoscreenElements = document.querySelectorAll(
		".infoscreen-spesific-product .product-info"
	);
	observeInfoscreenElements(infoscreenElements);
});

export function observeInfoscreenElements(elements) {
	intersectionObserve(elements, 0, 0, (element, intersectionRatio) => {
		(function (el) {
			if (intersectionRatio > 0) {
				getInfoscreenDepartures(el);
			}
		})(element);
	});
}

function formatTime(time, lang) {
	if (lang === "nb-NO") {
		return time.toLocaleTimeString("nb-NO", {
			hour: "2-digit",
			minute: "2-digit",
		});
	} else {
		return time.toLocaleTimeString("en-US", {
			timeStyle: "short",
		});
	}
}

function formatDate(date, lang) {
	if (lang === "nb-NO") {
		return date.toLocaleDateString("no-NB", {
			day: "numeric",
			month: "long",
		});
	} else {
		return date.toLocaleDateString("en-US", {
			day: "numeric",
			month: "long",
		});
	}
}

function getInfoscreenDepartures(element) {
	if (element.classList.contains("departures-loaded")) {
		return;
	}

	const todayDateTime = new Date();
	element.classList.add("departures-loaded");

	const productCode = element.getAttribute("data-iticket-productcode");
	const locationCode = element.getAttribute("data-iticket-locationcode");

	if (!productCode) {
		console.error("No product code found on element");
		return;
	}

	jQuery.ajax({
		type: "POST",
		url: rodne_scripts.ajax_url,
		data: {
			action: "get_product_departures",
			product_code: productCode,
			location_code: locationCode,
		},
		success: function (output) {
			let departures = output["departures"] || [];

			// Filter and process departures
			const timestamps = departures.map(
				(departure) => departure["datetime"]
			);
			departures = departures.filter((departure, index) => {
				return (
					timestamps.indexOf(departure["datetime"]) === index &&
					new Date(departure["datetime"]) >= todayDateTime &&
					(!departure["isFallback"] ||
						(departure["isFallback"] && index === 0))
				);
			});

			if (departures.length > 0) {
				displayDepartures(element, departures, todayDateTime);
			} else {
				displayNoDepartures(element);
			}
		},
		error: function () {
			console.error(
				"Failed to fetch departures for product code:",
				productCode
			);
			displayNoDepartures(element);
		},
	});
}

function displayDepartures(element, departures, todayDateTime) {
	const lang = document.documentElement.lang || "nb-NO";
	const todayDateString = todayDateTime.toISOString().split("T")[0];

	// Group departures by date
	const departuresByDate = departures.reduce((acc, departure) => {
		const date = new Date(departure["datetime"])
			.toISOString()
			.split("T")[0];
		acc[date] = acc[date] || [];
		acc[date].push(departure);
		return acc;
	}, {});

	const todaySection = element.querySelector(".departures .today");
	const followingSection = element.querySelector(".departures .following");

	// Clear existing content
	todaySection.innerHTML = "";
	followingSection.innerHTML =
		'<h2 class="font-step-4 bold c-rodne-blue departure-title">' +
		(lang === "nb-NO" ? "Kommende avganger" : "Following departures") +
		"</h2>";

	// Get all dates with departures, sorted
	const allDates = Object.keys(departuresByDate).sort();

	// Find the first date that has departures (could be today or a future date)
	let nextDeparturesDate = null;
	let followingDeparturesDate = null;

	for (const date of allDates) {
		if (date >= todayDateString) {
			if (!nextDeparturesDate) {
				nextDeparturesDate = date;
			} else if (!followingDeparturesDate) {
				followingDeparturesDate = date;
				break;
			}
		}
	}

	// Display next departures (could be today or tomorrow)
	if (nextDeparturesDate && departuresByDate[nextDeparturesDate]) {
		departuresByDate[nextDeparturesDate].forEach((departure) => {
			const time = formatTime(new Date(departure["datetime"]), lang);
			const capacity = departure["availableCapacity"];
			const isSoldOut = capacity === 0;

			const departureElement = document.createElement("p");
			departureElement.className = isSoldOut
				? "departure departure--sold-out font-step-1 c-rodne-blue"
				: "departure font-step-1 c-rodne-blue";

			let datePrefix;
			if (nextDeparturesDate === todayDateString) {
				datePrefix = lang === "nb-NO" ? "I dag kl. " : "Today at ";
			} else {
				const dateFormatted = formatDate(
					new Date(nextDeparturesDate),
					lang
				);
				datePrefix =
					dateFormatted + (lang === "nb-NO" ? " kl. " : " at ");
			}

			const timeText = datePrefix + time;
			departureElement.textContent = timeText;

			// Add sold out badge if needed
			if (isSoldOut) {
				const soldOutBadge = document.createElement("span");
				soldOutBadge.className = "sold-out-badge";
				soldOutBadge.textContent =
					lang === "nb-NO" ? "Utsolgt" : "Sold out";
				departureElement.appendChild(document.createTextNode(" "));
				departureElement.appendChild(soldOutBadge);
			}

			todaySection.appendChild(departureElement);
		});
	}

	// Display following departures (the day after next departures)
	if (followingDeparturesDate && departuresByDate[followingDeparturesDate]) {
		departuresByDate[followingDeparturesDate].forEach((departure) => {
			const time = formatTime(new Date(departure["datetime"]), lang);
			const dateFormatted = formatDate(
				new Date(followingDeparturesDate),
				lang
			);
			const capacity = departure["availableCapacity"];
			const isSoldOut = capacity === 0;

			const departureElement = document.createElement("p");
			departureElement.className = isSoldOut
				? "departure departure--sold-out font-step-3 c-rodne-blue"
				: "departure font-step-3 c-rodne-blue";

			const timeText =
				dateFormatted + (lang === "nb-NO" ? " kl. " : " at ") + time;
			departureElement.textContent = timeText;

			// Add sold out badge if needed
			if (isSoldOut) {
				const soldOutBadge = document.createElement("span");
				soldOutBadge.className = "sold-out-badge";
				soldOutBadge.textContent =
					lang === "nb-NO" ? "Utsolgt" : "Sold out";
				departureElement.appendChild(document.createTextNode(" "));
				departureElement.appendChild(soldOutBadge);
			}

			followingSection.appendChild(departureElement);
		});
	}

	// Hide following section if no following departures
	if (!followingDeparturesDate) {
		followingSection.style.display = "none";
	} else {
		followingSection.style.display = "block";
	}
}

function displayNoDepartures(element) {
	const lang = document.documentElement.lang || "nb-NO";
	const todaySection = element.querySelector(".departures .today");
	const followingSection = element.querySelector(".departures .following");

	todaySection.innerHTML =
		'<p class="departure font-step-1 c-rodne-blue">' +
		(lang === "nb-NO"
			? "Ingen avganger tilgjengelig"
			: "No departures available") +
		"</p>";

	followingSection.style.display = "none";
}
